import React from "react";
import { Link } from "gatsby";
import MakeItConsciousSymbols from "../icons/MakeItConsciousSymbols";
import RestaurantCardButtons from "../buttons/RestaurantCardButtons";
import PropTypes from "prop-types";
import RestaurantCardStyles from "../../styles/RestaurantCardStyles";
import MapPoint from "../icons/MapPoint";

const RestaurantCard = ({ restaurant, clickCard }) => {
  const {
    city,
    id,
    mongodb_id,
    name,
    cuisineRating,
    experienceRating,
    diversityRating,
    storyRating,
    sustainabilityRating,
    cuisine,
    meals,
    vibe,
    price,
    neighborhood,
    diningOptions,
    lifestyle,
    website,
    instagram,
    blurb,
    featured,
    articles,
    photos,
  } = restaurant;

  let phone = restaurant.phone;
  if (phone === "None") {
    phone = null;
  }

  const restId = id || mongodb_id;

  function replacePlantFocused() {
    const index = lifestyle.indexOf("Plant-focused");
    lifestyle.splice(index, 1, "Plant-based");
  }

  if (lifestyle.includes("Plant-focused")) {
    replacePlantFocused();
  }

  return (
    <RestaurantCardStyles>
      <div className="restaurant-card" id={`card-${restId}`}>
        {featured && <p className="highlighted-restaurant">Winter favorite</p>}
        <h3 className="restaurant-card__name">{name}</h3>
        <p className="restaurant-card__description">
          <span>{blurb}. </span>
          {/* {articles.length > 0 && (
            <span className="">
              Read more about {name} in:{" "}
              {articles.map(article => (
                <Link
                  key={article.name}
                  to={article.url}
                  className="article-link"
                >
                  {article.linkText}{" "}
                </Link>
              ))}
            </span>
          )} */}
        </p>

        {photos.length > 0 && (
          <img
            className="restaurant-card__photo"
            src={photos[0].url}
            alt={photos[0].altText}
          />
        )}
        {(experienceRating ||
          cuisineRating ||
          storyRating ||
          sustainabilityRating ||
          diversityRating) && (
          <div className="restaurant-card__info-row mt-1 mb-12">
            <h4 className="restaurant-card__label">Highlights</h4>
            <div className="restaurant-card__icons">
              <MakeItConsciousSymbols
                cuisineRating={cuisineRating}
                experienceRating={experienceRating}
                storyRating={storyRating}
                sustainabilityRating={sustainabilityRating}
                diversityRating={diversityRating}
              />
            </div>
          </div>
        )}
        {lifestyle?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Lifestyle</h4>
            <div className="restaurant-card__tags">
              {lifestyle.map(tag => {
                return <p key={tag}>{tag}</p>;
              })}
            </div>
          </div>
        )}
        {vibe?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Vibe</h4>
            <div className="restaurant-card__tags">
              {vibe.map(tag => {
                return <p key={tag}>{tag}</p>;
              })}
            </div>
          </div>
        )}
        {cuisine?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Cuisine</h4>
            <div className="restaurant-card__tags">
              {cuisine.map(tag => {
                return <p key={tag}>{tag}</p>;
              })}
            </div>
          </div>
        )}
        {meals?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Meal</h4>
            <div className="restaurant-card__tags">
              {meals.map(meal => {
                return <p key={meal}>{meal}</p>;
              })}
            </div>
          </div>
        )}
        {diningOptions?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Dining</h4>
            <div className="restaurant-card__tags">
              {diningOptions.map(tag => {
                return (
                  <p
                    // className={
                    //   tag === "Indoor seating" || tag === "Outdoor seating"
                    //     ? "restaurant-card__disabled-text"
                    //     : ""
                    // }
                    key={tag}
                  >
                    {tag}
                  </p>
                );
              })}
            </div>
          </div>
        )}
        {neighborhood?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">District</h4>
            <div className="restaurant-card__tags">
              {neighborhood.map(tag => {
                return <p key={tag}>{tag}</p>;
              })}
            </div>
          </div>
        )}
        {price?.length > 0 && (
          <div className="restaurant-card__info-row">
            <h4 className="restaurant-card__label">Price</h4>
            <div className="restaurant-card__tags">
              <p>{price}</p>
            </div>
          </div>
        )}
        <RestaurantCardButtons city={city} restaurantId={restId} name={name} />
        <div className="restaurant-card__map-point">
          <MapPoint clickCard={clickCard} restaurantId={restId} />
        </div>
        <div className="restaurant-card__contact">
          {website && (
            <a
              href={`http://${website}`}
              rel="noreferrer noopener"
              target="_blank"
              className="restaurant-card__website"
            >
              Website{" "}
            </a>
          )}
          {instagram && (
            <a
              href={instagram.link}
              rel="noreferrer noopener"
              target="_blank"
              className="restaurant-card__website restaurant-card__instagram"
            >
              Instagram{" "}
            </a>
          )}
          {phone && (
            <a
              href={`tel:${phone}`}
              className="restaurant-card__phone restaurant-card__website"
            >
              {phone}
            </a>
          )}
        </div>
      </div>
    </RestaurantCardStyles>
  );
};

RestaurantCard.propTypes = {
  restaurant: PropTypes.object.isRequired,
};

export default RestaurantCard;
